<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "copy-link" });
export let css = "";
export let isScaling = true;
</script>

<svg
    id='Link_24'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    xmlns:xlink='http://www.w3.org/1999/xlink'
    class = { `s8-icon ${ css }` }
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
>
    <rect width='24' height='24' stroke='none' fill='#000000' opacity='0'/>


    <g transform="matrix(0.83 0 0 0.83 12 12)" >
        <path
            style="stroke: none; stroke-width: 1; stroke-dasharray: none;
                stroke-linecap: butt;
                stroke-dashoffset: 0; stroke-linejoin: miter;
                stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule:
                nonzero; opacity: 0.4;"
            transform=" translate(-16, -16)"
            d="M 21.75 4 C 20.078125 4 18.492188
            4.660156 17.3125 5.84375 L 15.84375
            7.3125 C 14.660156 8.496094 14 10.078125
            14 11.75 C 14 12.542969 14.152344 13.316406
            14.4375 14.03125 L 16.0625 12.40625 C
            15.859375 11.109375 16.253906 9.714844
            17.25 8.71875 L 18.71875 7.25 C 19.523438
            6.445313 20.613281 6 21.75 6 C 22.886719 6 23.945313
            6.445313 24.75 7.25 C 26.410156
            8.910156 26.410156 11.621094 24.75 13.28125 L 23.28125
            14.75 C 22.476563 15.554688 21.386719 16 20.25 16 C
            20.027344 16 19.808594 15.976563 19.59375 15.9375 L
            17.96875 17.5625 C 18.683594 17.847656 19.457031 18 20.25 18 C 21.921875
            18 23.507813 17.339844 24.6875 16.15625 L 26.15625 14.6875
            C 27.339844 13.503906 28 11.921875 28 10.25 C 28 8.578125 27.339844
            7.027344 26.15625 5.84375 C 24.976563 4.660156 23.421875 4 21.75 4 Z M 19.28125 11.28125 L
            11.28125 19.28125 L 12.71875 20.71875 L 20.71875 12.71875 Z M 11.75 14 C 10.078125 14 8.492188 14.660156
            7.3125 15.84375 L 5.84375 17.3125 C 4.660156 18.496094 4 20.078125 4 21.75
            C 4 23.421875 4.660156 24.972656 5.84375 26.15625 C 7.023438 27.339844
            8.578125 28 10.25 28 C 11.921875 28 13.507813 27.339844 14.6875 26.15625
            L 16.15625 24.6875 C 17.339844 23.503906 18 21.921875 18 20.25 C 18 19.457031
            17.847656 18.683594 17.5625 17.96875 L 15.9375 19.59375 C 16.140625
            20.890625 15.746094 22.285156 14.75 23.28125 L 13.28125 24.75 C 12.476563 25.554688
            11.386719 26 10.25 26 C 9.113281 26 8.054688 25.554688 7.25 24.75
            C 5.589844 23.089844 5.589844 20.378906
            7.25 18.71875 L 8.71875 17.25 C 9.523438 16.445313 10.613281 16 11.75 16 C 11.972656 16 12.191406
            16.023438 12.40625 16.0625 L 14.03125 14.4375 C 13.316406 14.152344 12.542969 14 11.75 14 Z"
            stroke-linecap="round"
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }
        />
    </g>
</svg>